/**
 * KAN-755: API скидок и групп товаров. Контракт: types/discount.ts.
 * Организация не интернет-магазин: 404; правка без права users.manage: 403.
 */
import apiClient from './client';
import type {
  DiscountBody,
  DiscountDetail,
  DiscountsListParams,
  DiscountsListResponse,
  DiscountType,
  ProductGroup,
  ProductGroupBody,
} from '@/types/discount';

const BASE = '/api/v1/catalog/';

const discountUrl = (id: string): string => `${BASE}discounts/${encodeURIComponent(id)}/`;
const groupUrl = (id: string): string => `${BASE}groups/${encodeURIComponent(id)}/`;

/** Пустые фильтры в запрос не уходят. */
function cleanParams(params: DiscountsListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') out[key] = value;
  });
  return out;
}


export const discountsApi = {
  types: async (): Promise<DiscountType[]> =>
    (await apiClient.get<DiscountType[]>(`${BASE}discount-types/`)).data,
  list: async (params: DiscountsListParams): Promise<DiscountsListResponse> =>
    (await apiClient.get<DiscountsListResponse>(`${BASE}discounts/`, { params: cleanParams(params) })).data,
  get: async (id: string): Promise<DiscountDetail> =>
    (await apiClient.get<DiscountDetail>(discountUrl(id))).data,
  create: async (body: DiscountBody): Promise<DiscountDetail> =>
    (await apiClient.post<DiscountDetail>(`${BASE}discounts/`, body)).data,
  update: async (id: string, body: Partial<DiscountBody>): Promise<DiscountDetail> =>
    (await apiClient.patch<DiscountDetail>(discountUrl(id), body)).data,
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(discountUrl(id));
  },
};

export const productGroupsApi = {
  /** Простой список без пагинации; search по названию и описанию. */
  list: async (search?: string): Promise<ProductGroup[]> =>
    (await apiClient.get<ProductGroup[]>(`${BASE}groups/`, { params: search ? { search } : {} })).data,
  get: async (id: string): Promise<ProductGroup> => (await apiClient.get<ProductGroup>(groupUrl(id))).data,
  create: async (body: ProductGroupBody): Promise<ProductGroup> =>
    (await apiClient.post<ProductGroup>(`${BASE}groups/`, body)).data,
  update: async (id: string, body: Partial<ProductGroupBody>): Promise<ProductGroup> =>
    (await apiClient.patch<ProductGroup>(groupUrl(id), body)).data,
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(groupUrl(id));
  },
};
